import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMapEvents,
 } from 'react-leaflet';
 import L from 'leaflet';
import { VoteIndicator } from './AppBar/Guide';
import { ThumbDown, ThumbUp } from '@mui/icons-material';
import { useNavigateToTop } from '../libs/useNavigateToTop';

function LeafletMap({
    onViewChanged,
    guides,
    colours=[]
}) {
    const navigate = useNavigateToTop();
    function MapClickHandler() {
        useMapEvents({
            moveend: (e) => {
                onViewChanged(e.target.getBounds());
            }
        });

        return null;
    }
    // zoom={13} 
    
    
    // Markers for each bonsai guide
    const markers = guides.map((guide,index) => {
        const markerHtmlStyles = `
  background-color: ${colours[index]};
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  left: -.75rem;
  top: -.75rem;
  position: relative;
  border-radius: 2rem 2rem 0;
  transform: rotate(45deg);
  border: 1px solid #FFFFFF`
  ;
  const icon = L.divIcon({
    className: "my-custom-pin",
    iconAnchor: [0, 24],
    labelAnchor: [-6, 0],
    popupAnchor: [0, -36],
    html: `<span style="${markerHtmlStyles}" />`
  })
        let votes = {
            upVotes: guide.upVotes,
            downVotes: guide.downVotes
        }
        if (guide.geo) {
        return (
            <Marker 
            icon={icon}
            key={guide.storageDocumentId} position={[guide.geo.latitude, guide.geo.longitude]}>
                <Popup>
                    <Box>
                        <Typography variant="h6">{guide.commonName}</Typography>
                        <Typography variant='subtitle'>{guide.scientificName}</Typography>
                        <Stack
                        direction="row"
                        spacing={2}
                        style={{
                            marginTop: ".5rem",
                            alignItems: "center"
                        }}
                        >
                        <ThumbUp
        style={{
          fontSize: "1rem"
        }}
        />
        <Typography>
            {(votes.upVotes)? votes.upVotes.length: 0}
        </Typography>
        <ThumbDown
        style={{
            fontSize: "1rem"
        }}
        />
        <Typography>
            {(votes.downVotes)? votes.downVotes.length: 0}
        </Typography>

                        </Stack>
                        <Button 
                        onClick={() => {
                            navigate(`/bonsai-guide/${guide.storageDocumentId}`);
                        }
                        }
                        variant='outlined'
                        style={{
                            display:"block",
                            marginTop: ".5rem"
                        }}>
                            View Guide
                        </Button>
                        {/* <VoteIndicator votes={votes} /> */}
                        {/*  votes */}
                        {/*  location */}
                    </Box>
                </Popup>
            </Marker>
        );
    }
    return null;
    
    }
);

    return (
        <MapContainer center={[36.109, -95.895]} zoom={3}
        style={{ height: "70vh", width: "100%" }}
        maxBounds={[
            [90, -180],
            [-90, 180]
          
        ]}
        >
            <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
            <MapClickHandler />
            {markers}
        </MapContainer>
    );
}

export default LeafletMap;